<template>
    <div id="card-class-manage">
        <div class="vx-row flex justify-center">
            <div class="vx-col w-full">
                <div class="vx-card p-2">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full flex items-center">
                            <h4>Quản lý hạng thẻ</h4>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-button class="float-right" color="primary" @click="updateCardClass"
                                       v-if="!isUpdateCardClass">Cập nhật hạng thẻ
                            </vs-button>
                            <div class="float-right flex flex-wrap" v-if="isUpdateCardClass">
                                <vs-button color="primary" class="mr-2" @click="saveCardClass">Cập nhật</vs-button>
                                <vs-button color="danger" type="border" @click="isUpdateCardClass = false">Quay lại
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <VuePerfectScrollbar class="scroll-area--card" :settings="settings" :key="$vs.rtl">
                    <div class="mt-10 flex flex-wrap justify-center gap-10 list-card" v-if="!isUpdateCardClass">
                        <div v-for="(item, index) in cardClassData" :key="index"
                             v-if="cardClassData.length > 0">
                            <div class="vx-card py-4">
                                <div class="flex justify-center items-center">
                                    <div class="flip-card">
                                        <div class="flip-card-inner">
                                            <div class="flip-card-front items-center">
                                                <img :src="item.urlImage" alt="">
                                                <span class="absolute font-semibold text-lg">{{ item.name }}</span>
                                            </div>
                                            <div class="flip-card-back items-center">
                                                <img :src="item.urlImage" alt="">
                                                <span class="absolute font-semibold text-lg">
                                                {{ 'Điểm: ' + item.milestone }}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-8 px-2" v-if="item.descriptions && item.descriptions.length > 0">
                                    <div class="text-center">
                                        <span class="font-semibold text-xl text-primary">Quyền lợi</span>
                                    </div>
                                    <VuePerfectScrollbar ref="scrollDialog"
                                                         class="scroll-area--nofications-dropdown scroll mt-2"
                                                         :settings="settings">
                                        <div class="flex items-center text-justify mb-2"
                                             v-for="(text, ind) in item.descriptions" :key="ind">
                                    <span class="flex items-center mr-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                                             viewBox="0 0 24 24" fill="none">
<path
    d="M16 3.93552C14.795 3.33671 13.4368 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.662 20.9814 11.3283 20.9451 11M21 5L12 14L9 11"
    stroke="rgba(var(--vs-success),1)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                                    </span>
                                            <span>{{ text }}</span>
                                        </div>
                                    </VuePerfectScrollbar>
                                </div>
                            </div>
                        </div>
                        <div class="" v-if="cardClassData.length === 0">
                            <span>Không có dữ liệu</span>
                        </div>
                    </div>

                    <div class="" v-else>
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <vs-button class="float-right" color="primary" @click="addCardClass">Thêm thẻ</vs-button>
                            </div>
                        </div>
                        <div v-for="(item, index) in cardClassInfo" :key="index"
                             class="vx-row mt-4 list-info-card match-height">
                            <div class="vx-col md:w-1/3 w-1/2 flex items-center justify-center">
                                <div class="card-img flex justify-center" v-if="item.image" @click="selectImage(index)">
                                    <img :src="item.image.src" alt="">
                                </div>
                                <div class="card-no-img" v-if="!item.image" @click="selectImage(index)">
                                    <div class="flex items-center justify-center h-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px"
                                             viewBox="0 0 24 24"
                                             fill="none">
                                            <rect width="24" height="24" fill="white"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                                                  fill="#323232"/>
                                        </svg>
                                        <span>Thêm ảnh thẻ</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-2/3 w-1/2">
                                <div class="vx-card px-4 pt-2">
                                    <div class="vx-row">
                                        <div class="vx-col w-full absolute">
                                            <vx-tooltip :text="$t('button.delete')" position="top" color="danger"
                                                        class="float-right">
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                                     fill="rgba(var(--vs-danger), 1)" version="1.1" id="Ebene_1"
                                                     width="20px" height="20px"
                                                     viewBox="0 0 64 64" enable-background="new 0 0 64 64"
                                                     xml:space="preserve" class="cursor-pointer" @click="deleteCard(index)">
<g>
	<path
        d="M17.586,46.414C17.977,46.805,18.488,47,19,47s1.023-0.195,1.414-0.586L32,34.828l11.586,11.586   C43.977,46.805,44.488,47,45,47s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L34.828,32l11.586-11.586   c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L32,29.172L20.414,17.586c-0.781-0.781-2.047-0.781-2.828,0   c-0.781,0.781-0.781,2.047,0,2.828L29.172,32L17.586,43.586C16.805,44.367,16.805,45.633,17.586,46.414z"/>
    <path
        d="M32,64c8.547,0,16.583-3.329,22.626-9.373C60.671,48.583,64,40.547,64,32s-3.329-16.583-9.374-22.626   C48.583,3.329,40.547,0,32,0S15.417,3.329,9.374,9.373C3.329,15.417,0,23.453,0,32s3.329,16.583,9.374,22.626   C15.417,60.671,23.453,64,32,64z M12.202,12.202C17.49,6.913,24.521,4,32,4s14.51,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32   s-2.913,14.51-8.202,19.798C46.51,57.087,39.479,60,32,60s-14.51-2.913-19.798-8.202C6.913,46.51,4,39.479,4,32   S6.913,17.49,12.202,12.202z"/>
</g>
</svg>
                                            </vx-tooltip>
                                        </div>
                                        <div class="vx-col w-1/2 mt-1">
                                            <label class="vs-input--label required">Tên hạng thẻ</label>
                                            <vs-input class="w-full" v-model="item.name"></vs-input>
                                            <span class="text-danger text-sm">{{ errors.first('nameCardClass') }}</span>
                                        </div>
                                        <div class="vx-col w-1/2 mt-1">
                                            <label class="vs-input--label required">Điểm thẻ</label>
                                            <vs-input class="w-full" v-model="item.milestone"
                                                      @input="checkTypeInput"></vs-input>
                                            <span class="text-danger text-sm">{{ errors.first('cardMilestone') }}</span>
                                        </div>
                                        <div class="vx-col w-full mt-2">
                                            <label class="vs-input--label">Quyền lợi</label>
                                            <vs-textarea class="w-full" v-model="item.benefit" @input="check(item, index)"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input type="file" ref="imageCardInput" accept="image/*" @change="handleImageUpload"
                           class="hidden"/>
                </VuePerfectScrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    name: "CardClassManage",
    components: {
        VuePerfectScrollbar
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            cardClassData: [],
            isUpdateCardClass: false,
            cardClassInfo: [
                {
                    benefit: null,
                    cardImage: null,
                    descriptions: null,
                    image: null,
                    milestone: null,
                    name: null,
                    orders: null,
                    urlImage: null,
                }
            ],
            indexSelected: null,
            typingTimer: null,
        }
    },

    async created() {

        await this.getAllCardClass();
    },

    methods: {
        check(data, ind) {
            console.log(this.cardClassInfo[ind].benefit)
        },
        getAllCardClass() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get('/setting/organization-card/find-by-organization-id').then(res => {
                    if (res.data && res.data.length > 0) {
                        const cardClassData = []
                        res.data.forEach(x => {
                            x.urlImage = x.cardImage ? x.cardImage.url : null;
                            x.benefit = x.descriptions && x.descriptions.join('\r\n')
                            cardClassData.push(x)
                        })
                        this.cardClassData = cardClassData
                    }
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        async updateCardClass() {
            this.$vs.loading();
            if (this.cardClassData.length > 0) {
                this.cardClassInfo = [];
                for (const el of this.cardClassData) {
                    let data = await this.toDataURL(el.urlImage);
                    el.image = await this.convertImage(data, this.cardClassData.indexOf(el));
                    this.cardClassInfo.push(el);
                }
            }
            this.isUpdateCardClass = true;
            this.$vs.loading.close();
        },

        convertImage(data, index) {
            return new Promise((resolve) => {
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], `${index}.png`, metadata);
                file.src = data.imgBase64;
                resolve(file);
                return file;
            })
        },

        addCardClass() {
            let data = {
                benefit: null,
                cardImage: null,
                descriptions: null,
                image: null,
                milestone: null,
                name: null,
                orders: null,
                urlImage: null,
            }
            this.cardClassInfo.push(data);
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        selectImage(index) {
            this.indexSelected = index;
            this.$refs.imageCardInput.click();
        },

        handleImageUpload(event) {
            let imageUpload = [...event.target.files];
            imageUpload.forEach((file) => {
                file.file = new File([file], `${this.indexSelected}.png`, {type: file.type});
                const reader = new FileReader();
                reader.onload = function (e) {
                    file.file.src = e.target.result;
                }
                reader.readAsDataURL(file);
            });

            this.cardClassInfo[this.indexSelected].image = imageUpload[0].file;
            let data = this.cardClassInfo;
            this.cardClassInfo = [];
            setTimeout(() => {
                this.cardClassInfo = data;
            }, 50)

            // Clear the file input
            this.$refs.imageCardInput.value = null;
        },

        deleteCard(index) {
            this.cardClassInfo.splice(index, 1);
        },

        checkTypeInput(event) {
            let regexString = /[a-zA-Z]/;
            if (regexString.test(event)) {
                return this.$vs.notify({
                    text: 'Điểm thẻ phải là chữ số!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
        },

        saveCardClass() {
            let regexString = /[a-zA-Z]/;
            let checkNotNumber = this.cardClassInfo.filter(el => regexString.test(el.milestone));
            if (checkNotNumber.length > 0) {
                return this.$vs.notify({
                    text: 'Điểm thẻ phải là chữ số!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let checkValidate = this.cardClassInfo.filter(el => !el.name || el.milestone === null);
            if (checkValidate.length > 0) {
                return this.$vs.notify({
                    text: 'Không được để trống trường bắt buộc (*)!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let checkImage = this.cardClassInfo.filter(el => !el.image);
            if (checkImage.length > 0) {
                return this.$vs.notify({
                    text: 'Ảnh thẻ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            const formData = new FormData();
            this.cardClassInfo.forEach(el => {
                el.orders = this.cardClassInfo.indexOf(el);
                el.benefit = el.benefit ? el.benefit.replaceAll('\r', '') : null;
                let desc = el.benefit ? el.benefit.split('\n') : null;
                el.descriptions = desc ? desc.filter(x => x.length > 0) : null;
                formData.append('files', el.image);
            });

            let requestDTOs = this.cardClassInfo;
            requestDTOs = requestDTOs.map(el => {
                return {
                    name: el.name,
                    orders: el.orders,
                    descriptions: el.descriptions,
                    milestone: el.milestone
                }
            })
            const blob = new Blob([JSON.stringify(requestDTOs)], {type: 'application/json'});
            formData.append('requestDTOs ', blob);

            this.$vs.loading();
            this.$crm.post('/setting/organization-card/save', formData).then(async () => {
                this.$vs.notify({
                    text: 'Cập nhật hạng thẻ thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$vs.loading.close();
                this.isUpdateCardClass = false;
                await this.getAllCardClass();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
#card-class-manage {
    .list-card {
        .vx-card {
            width: 300px;
            height: 100%;
        }

        img {
            width: 250px;
            height: 190px;
            border-radius: 1rem;
        }

        .flip-card {
            background-color: transparent;
            width: 250px;
            height: 190px;
            perspective: 1000px;
            font-family: sans-serif;
        }

        .title {
            font-size: 1.5em;
            font-weight: 900;
            text-align: center;
            margin: 0;
        }

        .flip-card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            text-align: center;
            transition: transform 0.8s;
            transform-style: preserve-3d;
        }

        .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
        }

        .flip-card-front, .flip-card-back {
            box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
            position: absolute;
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            height: 100%;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            border-radius: 1rem;
        }

        .flip-card-back {
            transform: rotateY(180deg);
        }
    }

    .list-info-card {
        .card-img {
            border-radius: 1rem;
            height: 100%;
            margin-left: 20px;
            cursor: pointer;

            img {
                width: 250px;
                height: 190px;
            }
        }

        .card-no-img {
            border: dashed 1px #cccccc;
            border-radius: 1rem;
            height: 100%;
            width: 100%;
            margin-left: 20px;
            cursor: pointer;
        }

        .card-no-img:hover {
            border: dashed 1px rgba(var(--vs-primary), 1);

            span {
                color: rgba(var(--vs-primary), 1);
            }

            svg path {
                fill: rgba(var(--vs-primary), 1);
            }
        }
    }

    .scroll-area--card {
        //height: 500px;
    }
}
</style>
